import { Reducer } from '@reduxjs/toolkit'

import { RECEIVE_REASONS, REQUEST_REASONS } from '@/actions'
import { ReasonsSlice } from '@/models'

const initialState = {
    activeReasons: [],
    fetchSuccessful: null,
    shouldFetch: true,
}

const reasonsReducer: Reducer<ReasonsSlice> = (currentState, { type, data }) => {
    const state = currentState ?? initialState

    switch (type) {
        case REQUEST_REASONS:
            return { ...state, ...data, shouldFetch: false }

        case RECEIVE_REASONS:
            return { ...state, ...data }

        default:
            return state
    }
}

export default reasonsReducer
